<div class="
    black-checkbox
    new-table-style example-container-measurestatusdefinitions">

  <table mat-table
    [dataSource]="dataSource"
    multiTemplateDataRows
    matSort
    class="mat-elevation-z8 mat-table-custom" id="MeasuresInfoStatus">

    <ng-container matColumnDef="arrow">
      <th mat-header-cell *matHeaderCellDef>
        @if (!isAllCollapsed) {
          <mat-icon (click)="collapseOrExpandAll()">expand_more</mat-icon>
        }
        @if (isAllCollapsed) {
          <mat-icon (click)="collapseOrExpandAll()">expand_less</mat-icon>
        }
      </th>
      <td mat-cell *matCellDef="let element" (click)="pushPopElement(element)">
        <ng-container>
          @if (checkExpanded(element)) {
            <mat-icon>
              expand_less
            </mat-icon>
          } @else {
            <mat-icon matTooltip="Show Action Items">
              expand_more
            </mat-icon>
          }
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef> Measure </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.Name | bold: dataSource.filter"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="Description">
      <th mat-header-cell *matHeaderCellDef> Description </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.Description | bold: dataSource.filter"></p>
      </td>
    </ng-container>


    <ng-container matColumnDef="Kpi">
      <th mat-header-cell *matHeaderCellDef> KPI </th>
      <td mat-cell *matCellDef="let measure">
        <p [innerHTML]="measure.KpiName"></p>
      </td>
    </ng-container>

    <ng-container matColumnDef="StatusQX">
      <th mat-header-cell *matHeaderCellDef> Measure Status </th>
      <td mat-cell class="dropdownCell" *matCellDef="let measure">
        <p [innerHTML]="measure.StatusQXDesc" [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
        <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }"
          class="integratedNgSelect"
          [items]="statusesQX"
          bindLabel="Description"
          bindValue="StatusQXId"
          [clearable]="false"
          [searchable]="false"
          [(ngModel)]="measure.StatusQXId"
          [clearOnBackspace]="false"
          (ngModelChange)="onStatusQXChange(measure.MeasureId, measure.StatusQXId)">
        </ng-select>
      </td>
    </ng-container>

    <ng-container matColumnDef="measureStatusHistory">
      <th mat-header-cell *matHeaderCellDef>Change Log</th>
      <td mat-cell *matCellDef="let measure" class="notEditable">
        <compact-history-button
          [item]="measure"
          tooltip="View Change Log"
          buttonText="Get History"
          (historyClick)="onMeasureStatusHistoryDetail($event)">
        </compact-history-button>
      </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="actionitems">
      <td mat-cell class="dropdownCell" *matCellDef="let measure" [attr.colspan]="columnsToDisplay.length">
        <div [@detailExpand]="checkExpanded(measure) ? 'expanded' : 'collapsed'"
          id="MeasureActionItemsStatus">
          <table mat-table
            [dataSource]="measure.ActionItems"
            class="mat-subtable-custom">

            <ng-container matColumnDef="ItemNo">
              <th mat-header-cell *matHeaderCellDef>Action</th>
              <td mat-cell *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.Name | bold: dataSource.filter" style="padding-left:24px"></p>
              </td>
            </ng-container>

            <ng-container matColumnDef="Description">
              <th mat-header-cell *matHeaderCellDef> Description </th>
              <td mat-cell *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.Description | bold: dataSource.filter"></p>
              </td>
            </ng-container>

            <ng-container matColumnDef="Owner">
              <th mat-header-cell *matHeaderCellDef> Owner </th>
              <td mat-cell *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.Owner | bold: dataSource.filter"></p>
              </td>
            </ng-container>

            <ng-container matColumnDef="Comments">
              <th mat-header-cell *matHeaderCellDef> Comments </th>
              <td mat-cell *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.Comments | bold: dataSource.filter"></p>
              </td>
            </ng-container>

            <ng-container matColumnDef="Deadline">
              <th mat-header-cell *matHeaderCellDef> Deadline </th>
              <td mat-cell *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.Deadline | bold: dataSource.filter | date:'yyyy-MM-dd'"></p>
              </td>
            </ng-container>

            <ng-container matColumnDef="StatusQ1">
              <th mat-header-cell *matHeaderCellDef> Check-in 1 </th>
              <td mat-cell class="dropdownCell" *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.StatusDescQ1" [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
                <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }"
                  class="integratedNgSelect"
                  [items]="statuses"
                  bindLabel="Description"
                  bindValue="StatusId"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="actionItem.StatusQ1"
                  [clearOnBackspace]="false"
                  (ngModelChange)="onChange(actionItem.ActionItemId, actionItem.StatusQ1,1,actionItem.ActionItemStatusQ1Id)">
                </ng-select>
              </td>
            </ng-container>
            <ng-container matColumnDef="StatusQ2">
              <th mat-header-cell *matHeaderCellDef> Check-in 2 </th>
              <td mat-cell class="dropdownCell" *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.StatusDescQ2" [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
                <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }"
                  class="integratedNgSelect"
                  [items]="statuses"
                  bindLabel="Description"
                  bindValue="StatusId"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="actionItem.StatusQ2"
                  [clearOnBackspace]="false"
                  (ngModelChange)="onChange(actionItem.ActionItemId, actionItem.StatusQ2,2,actionItem.ActionItemStatusQ2Id)">
                </ng-select>
              </td>
            </ng-container>
            <ng-container matColumnDef="StatusQ3">
              <th mat-header-cell *matHeaderCellDef> Check-in 3 </th>
              <td mat-cell class="dropdownCell" *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.StatusDescQ3" [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
                <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }"
                  class="integratedNgSelect"
                  [items]="statuses"
                  bindLabel="Description"
                  bindValue="StatusId"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="actionItem.StatusQ3"
                  [clearOnBackspace]="false"
                  (ngModelChange)="onChange(actionItem.ActionItemId, actionItem.StatusQ3,3,actionItem.ActionItemStatusQ3Id)">
                </ng-select>
              </td>
            </ng-container>
            <ng-container matColumnDef="StatusQ4">
              <th mat-header-cell *matHeaderCellDef> Check-in 4 </th>
              <td mat-cell class="dropdownCell" *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.StatusDescQ4" [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
                <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }"
                  class="integratedNgSelect"
                  [items]="statuses"
                  bindLabel="Description"
                  bindValue="StatusId"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="actionItem.StatusQ4"
                  [clearOnBackspace]="false"
                  (ngModelChange)="onChange(actionItem.ActionItemId, actionItem.StatusQ4,4,actionItem.ActionItemStatusQ4Id)">
                </ng-select>
              </td>
            </ng-container>

            <ng-container matColumnDef="FinalStatus">
              <th mat-header-cell *matHeaderCellDef> Final Status </th>
              <td mat-cell class="dropdownCell" *matCellDef="let actionItem">
                <p [innerHTML]="actionItem.FinalStatusDesc" [style.display]="isEditModeEnabled === false ? 'block' : 'none'"></p>
                <ng-select [ngClass]="{'hidden': isEditModeEnabled === false }"
                  class="integratedNgSelect"
                  [items]="statuses"
                  bindLabel="Description"
                  bindValue="StatusId"
                  [clearable]="false"
                  [searchable]="false"
                  [(ngModel)]="actionItem.FinalStatus"
                  [clearOnBackspace]="false"
                  (ngModelChange)="onChange(actionItem.ActionItemId, actionItem.FinalStatus, 5,actionItem.ActionItemFinalStatusId)">
                </ng-select>
              </td>
            </ng-container>

            <ng-container matColumnDef="StatusComments">
              <th mat-header-cell *matHeaderCellDef> Status Comments </th>
              <td mat-cell *matCellDef="let actionItem">
                                <textareaoverlay [inputControls]="{
                                                  isOpenOverlay: false,
                                                  textAreaId: 'Notes_ta_',
                                                  isEditable: isEditModeEnabled,
                                                  maxCommentLength: 2000,
                                                  comment: actionItem.StatusComments
                                                  }"
                  [customSpanClass]="{'boldText': !isEditModeEnabled}"
                  (commentChange)="onStatusCommentsChange(actionItem,$event.comment)">
                </textareaoverlay>
              </td>
            </ng-container>

            <ng-container matColumnDef="actionStatusHistory">
              <th mat-header-cell *matHeaderCellDef>Change Log</th>
              <td mat-cell *matCellDef="let actionItem" class="notEditable">
                <compact-history-button
                  [item]="actionItem"
                  buttonText="Get History"
                  (historyClick)="onActionStatusHistoryDetail($event)">
                </compact-history-button>
              </td>
            </ng-container>

            <tr mat-header-row class="subtableheader" *matHeaderRowDef="subcolumnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row2; let i2 = index; columns: subcolumnsToDisplay;" class="subitem"
            [class.alternative2]="isEditModeEnabled === true"></tr>
          </table>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay"></tr>
    <tr mat-row *matRowDef="let measure; let i = dataIndex; columns: columnsToDisplay;"
      class="item" [class.alternative2]="isEditModeEnabled === true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['actionitems']" class="row-subitem"></tr>
  </table>
</div>



